import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import css from "./FormActions.module.css";

const FormActions = React.forwardRef(
  (
    { start, sticky = true, as: Component = "div", className, children },
    ref,
  ) => (
    <Component
      ref={ref}
      className={clsx(css.root, !sticky && css.nonSticky, className)}
    >
      {start}
      <div className={css.end}>{children}</div>
    </Component>
  ),
);

FormActions.displayName = "FormActions";

FormActions.propTypes = {
  start: PropTypes.node,
  sticky: PropTypes.bool,
  as: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default FormActions;
